const PACIFIC_TIME_ZONE = "America/Los_Angeles"

const PACIFIC_HOUR_FORMATTER = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  hourCycle: "h23",
  timeZone: PACIFIC_TIME_ZONE,
})

// Suggested prompts offered as pills below the composer. These lean on Sofia's
// highest-leverage, reliably-accurate skills: analyzing existing workspace data
// (failures, regressions, coverage gaps), summarizing runs, suggesting metrics,
// and authoring/strengthening test sets — the same capabilities surfaced in the
// panel's per-page suggested prompts.
export const HOME_SOFIA_SUGGESTED_PROMPTS: string[] = [
  "Show me where quality slipped this week",
  "Explain which metrics are failing most, and why",
  "Find the weakest coverage in my test sets",
  "Summarize my latest run and what needs follow-up",
  "Suggest edge cases I haven't tested yet",
  "Find the likely root cause of a failed simulation",
  "Recommend what I should evaluate next",
  "Spot regressions I should investigate",
]

export const HOME_SOFIA_ONBOARDING_SUGGESTED_PROMPTS: string[] = [
  "I want to run simulations",
  "I want to evaluate uploaded conversations",
  "Show me how Coval works",
  "I want to explore on my own",
]

export const HOME_SOFIA_CONNECTED_AGENT_SUGGESTED_PROMPTS: string[] = [
  "Validate my connected agent with a smoke test",
  "Help me upload conversations to evaluate",
  "Build a small first test set for my agent",
  "I want to explore on my own",
]

export const HOME_SOFIA_CONNECT_AGENT_SUGGESTED_PROMPTS: string[] = [
  "Help me connect a voice or chat agent",
  "Analyze my uploaded conversations first",
  "Show me the best next step",
  "I want to explore on my own",
]

export function getPacificGreeting(date: Date = new Date()): string {
  const hour = Number(PACIFIC_HOUR_FORMATTER.format(date))

  if (hour < 12) {
    return "Good morning"
  }
  if (hour < 17) {
    return "Good afternoon"
  }
  return "Good evening"
}
